import React from 'react'
import { PageAnalyzerResult } from '../../../hooks/use-page-analyzer'

export const RemoteErrorMessageDisplay = ({ error }: { error: PageAnalyzerResult['error'] }) => {
    if (!error) return null

    return (
        <span>
            {error.message}
            {error.referenceUrl && (
                <>
                    &nbsp;See our&nbsp;
                    <a href={error.referenceUrl} target="_blank" rel="noopener noreferrer">
                        documentation
                    </a>
                    &nbsp;for more information on this error.
                </>
            )}
        </span>
    )
}
